export const FREE_FALLBACK = {
  planType: "FREE",
  canCustomize: false,
  isFreePlan: true,
  unlimitedAccess: false,
};

const isActiveStatus = (status) => status === "ACTIVE" || status === "TRIALING";

const isPaidPlan = (planType) =>
  planType === "INDIVIDUAL" || planType === "COMPANY";

export const canUsePaidFeature = (subscription, unlimitedAccess) => {
  if (!subscription) return false;
  if (unlimitedAccess) return true;
  return (
    isPaidPlan(subscription.planType) && isActiveStatus(subscription.status)
  );
};
